
import UnsaveGuardMixin from '@/components/UnsaveGuardMixin';

import { Component, Ref } from 'vue-property-decorator';
import LocationView from './components/LocationView.vue';
import ShopInspectionRecord from './components/ShopInspectionRecord.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import AuditService from '@/services/audit.service';
import AddVirtualPoi from './components/AddVirtualPoi.vue';
import AlbumManagement from './components/AlbumManagement.vue';
import LookVirtualPoi from './components/LookVirtualPoi.vue';

import {
  ShopDetail as ShopDetailInterface,
  Staff,
  MerchantInfo,
  MerchantSettledEnum,
  IShopFormField,
  IEditShopFieldAddress,
} from '@/common/interface/shop';
import {
  EOperationType,
  EShopParkNum,
  EShopBusinessStatus,
  EShopField,
  EShopBusinessPOI,
} from '@/common/enum/shop';
import VueQr from 'vue-qr';
import BusinessStatusControl from './components/BusinessStatusControl.vue';
import ShopTransfer from './components/ShopTransfer.vue';
import { AuthEnum } from '@/services/permission.service';
import SPUTable from './components/SPUTable.vue';
import SuspendAccountControl from './components/SuspendAccountControl.vue';
import { $delay } from '@/common/utils';
import COrderListModal from './components/COrderListModal.vue';
import DrawQRCodePoster from './components/DrawQRCodePoster.vue';
import VideoUModal from '@/components/video/VideoModal.vue';
import ShopEditor from './components/ShopEditor.vue';
import { component as Viewer } from 'v-viewer';
import LookPhone from '@/components/LookPhone.vue';
import UTILService from '@/services/utils.service';
import ExitBrandModal from './components/ExitBrandModal.vue';
import SPUService from '@/services/spu.service';
import StoreSupport from './components/StoreSupport.vue';
import UnbindShopModal from './components/UnbindShopModal.vue';
import { DebounceTime } from '@/common/decorator';
import SystemService from '@/services/system.service';
import ImageService from '@/services/image.service';
import AMapLoader from '@amap/amap-jsapi-loader';
import RevisionRecordTable from './components/RevisionRecordTable.vue';
import MultipleModal from './components/MultipleModal.vue';
import ShoplLicenseModal from './components/ShoplLicenseModal.vue';
import IDcardModal from './components/IDcardModal.vue';
import AutoPauseResume from './components/AutoPauseResume.vue';
import CertificateDrawer from './components/CertificateDrawer.vue';
import OperatingData from './components/OperatingData.vue';
import MerchantDivision from './components/MerchantDivision.vue';
import ChangePoiModal from './components/ChangePoiModal.vue';

const AuthPhoneStatusEnum = {
  0: '已生成认证URL',
  1: '已提交',
  2: '认证中',
  3: '认证成功',
  4: '认证失败',
  null: '未认证',
};
const initMerchantInfo = {
  info: '',
  status: -2,
  merchantShopId: '',
};
const initialDetail = {
  address: ' - ',
  bossIdImage: [],
  bossTels: ' - ',
  businessStatus: ' - ',
  businessTime: '',
  dataChed: null,
  bossId: 0,
  discount: ' - ',
  latitude: ' - ',
  longitude: ' - ',
  mainBusiness: [],
  managerTels: ' - ',
  name: ' - ',
  parkNum: null,
  poi: ' - ',
  qrcode: ' - ',
  restArea: null,
  shopId: 0,
  shopImages: [],
  shopVideos: [],
  videos: [],
  shoplicense: [],
  startTime: ' - ',
  station: null,
  tels: ' - ',
  mechaniscs: [],
  staffList: {},
  advertiserMobilePhoneNumber: '',
  region: '',
  encrypt_ad_user_phone: '',
  encrypt_boss_phone: '',
  encrypt_manager_phone: '',
  encrypt_tels: '',
  encrypt_pre_tels: '',
  isKaShop: '',
  onsiteServiceFlag: '-',
  commission_ratio: '',
  commission_time: '',
  pre_tels: '-',
  roadTransportBusinessLicense: [],
  maintenanceOperationalVehicles: [],
  otherQualifications: [],
  mainBusinessAtagCode: '',
  businessRange: [],
  merchantOrderFailReason: '',
  createRightsStatus: '',
  is_album: 0,
};

enum EPayeeAccountFreezeStatus {
  正常 = 0,
  冻结 = 1,
}

const PayeeAccountFreezeStatusMap = new Map([
  [EPayeeAccountFreezeStatus.正常, '正常'],
  [EPayeeAccountFreezeStatus.冻结, '冻结'],
]);
enum EnumBizRange {
  洗车 = 1,
  汽车保养 = 2,
  钣金喷漆 = 3,
  轮胎养护 = 4,
  美容装潢 = 5,
  汽车维修 = 6,
}

declare const AMap: any;
@Component({
  components: {
    LocationView,
    ShopInspectionRecord,
    VueQr,
    BusinessStatusControl,
    ShopTransfer,
    SPUTable,
    SuspendAccountControl,
    COrderListModal,
    DrawQRCodePoster,
    VideoUModal,
    ShopEditor,
    Viewer,
    'look-phone': LookPhone,
    'exit-brand-modal': ExitBrandModal,
    StoreSupport,
    'unbind-shop-modal': UnbindShopModal,
    AddVirtualPoi,
    RevisionRecordTable,
    MultipleModal,
    ShoplLicenseModal,
    IDcardModal,
    AlbumManagement,
    LookVirtualPoi,
    AutoPauseResume,
    CertificateDrawer,
    OperatingData,
    MerchantDivision,
    ChangePoiModal,
  },
})
export default class VirtualShopDetail extends UnsaveGuardMixin {
  PayeeAccountFreezeStatusMap = PayeeAccountFreezeStatusMap;

  EPayeeAccountFreezeStatus = EPayeeAccountFreezeStatus;
  geocoder = '';
  AuthPhoneStatusEnum = AuthPhoneStatusEnum;

  AuthEnum = AuthEnum;

  shopTotal = '';

  radius = 5000;

  activeTab = '1';

  multipleData: any = {};

  editType = '1';

  lng = '-1';

  lat = '-1';

  PoiList: any = [];

  map: any = null;

  BusinessAtagName = '';

  adUserBind = false;

  idCardInfo: any = {};

  businessLicenseInfo: any = {};
  idCardType = false;

  locationName = '';

  EShopBusinessStatus = EShopBusinessStatus;

  EShopBusinessPOI = EShopBusinessPOI;

  EShopParkNum = EShopParkNum;

  editShopDrawerVisible = false;

  EShopField = EShopField;

  MerchantSettledEnum = MerchantSettledEnum;

  isDrawing = false;

  shopDate: any = {
    stopDate: '',
    startDate: '',
  };

  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(UTILService)
  private utilService!: UTILService;

  @lazyInject(AuditService)
  protected auditService!: AuditService;

  @lazyInject(ImageService)
  protected imageService!: ImageService;

  @Ref('unbindShopModal')
  unbindShopModal!: any;

  @Ref('changePoiModal')
  changePoiModal!: ChangePoiModal;

  @Ref('revisionRecordTable')
  revisionRecordTable!: RevisionRecordTable;

  @Ref('multipleModal')
  multipleModal!: MultipleModal;

  @Ref('shoplLicenseModal')
  shoplLicenseModal!: ShoplLicenseModal;

  @Ref('idCardModal')
  idCardModal!: IDcardModal;

  @Ref('albumManagement')
  albumManagement!: AlbumManagement;

  @Ref('lookVirtualPoi')
  lookVirtualPoi!: LookVirtualPoi;

  @Ref('autoPauseResume')
  autoPauseResume!: AutoPauseResume;

  @Ref('certificateDrawer')
  certificateDrawer!: CertificateDrawer;

  @Ref('merchantDivision')
  merchantDivision!: MerchantDivision;

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  @lazyInject(SystemService)
  protected SystemService!: SystemService;

  @Ref()
  transfer!: ShopTransfer;

  @Ref()
  locationView!: LocationView;

  @Ref()
  addVirtualPoi!: AddVirtualPoi;

  @Ref()
  shopInspectionRecord!: ShopInspectionRecord;

  @Ref()
  businessControl!: BusinessStatusControl;

  @Ref('lookPhone')
  lookPhone!: LookPhone;

  @Ref('exitBrandModal')
  exitBrandModal!: ExitBrandModal;

  @Ref('operatingData')
  operatingData!: OperatingData;

  @Ref()
  suspendAccount!: SuspendAccountControl;

  @Ref()
  cOrderListModal!: COrderListModal;

  @Ref()
  drawQRCodePoster!: DrawQRCodePoster;

  @Ref()
  videoModal!: VideoUModal;

  @Ref()
  shopEditor!: ShopEditor;

  @Ref()
  storeSupport!: StoreSupport;

  shopId?: string;

  detail: ShopDetailInterface = initialDetail;

  merchantInfo: MerchantInfo = initMerchantInfo;

  addressInfo: IEditShopFieldAddress = {
    address: '',
    regions: [] as number[],
    latitude: '',
    longitude: '',
    locationName: '',
  };

  columns = [
    {
      title: '坐标',
      dataIndex: 'lnglat',
      key: 'lnglat',
      align: 'center',
      width: 80,
    },
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 80,
    },
    {
      title: '地址',
      dataIndex: 'address',
      key: 'address',
      align: 'center',
      width: 80,
    },
    {
      title: '覆盖半径',
      dataIndex: 'radius',
      key: 'radius',
      align: 'center',
      width: 80,
    },
    // {
    //   title: '操作',
    //   dataIndex: 'action',
    //   key: 'action',
    //   align: 'center',
    //   width: 80,
    //   scopedSlots: { customRender: 'action' },
    // },
  ];

  get mechaniscs() {
    return this.detail.mechaniscs.map(({ id, name, introduce, picId }) => ({
      id,
      name,
      introduce,
      url: picId[0]?.url,
    }));
  }

  get staffList(): Staff[] {
    return Object.values(this.detail.staffList)
      .map(({ data }) => data)
      .reduce((prev, cur) => prev.concat(cur), []);
  }

  get fullAddress() {
    if (!this.detail.shopId) {
      return '';
    }
    const regions = this.detail.region.split('/');
    if (regions[0] === regions[1]) {
      regions.shift();
    }
    return regions.join('') + this.detail.address;
  }

  changePoi(val: any) {
    //  console.log(val);
    this.changePoiModal.init(val);
  }

  getdetailRegion() {
    if (!this.detail.shopId) {
      return '';
    }
    const regions = this.detail.region.split('/');
    const cityList = ['北京市', '天津市', '重庆市', '上海市'];
    if (regions[0] === regions[1]) {
      if (!cityList.includes(regions[0])) {
        regions.shift();
      }
    }
    return regions.join('/');
  }

  isLoading = false;

  captureDate(val: any) {
    return val.split(' ')[0];
  }

  getCertificate() {
    this.certificateDrawer.init();
  }
  openStoreSupport() {
    this.storeSupport.open(this.detail);
  }

  openUnbindModal() {
    this.unbindShopModal.init(this.shopId as string);
  }

  async openCOrderListModal() {
    await this.cOrderListModal.open();
  }
  LookShopDetail(type: string, val: any, poi: string) {
    this.lookPhone.init(type, val, poi);
  }
  openExitBrandModal() {
    this.exitBrandModal.init();
  }

  onCopySuccess() {
    this.$message.success('复制成功');
  }
  async privacyFun(val: any) {
    const res = await this.shopService.privacyPhone({
      shopId: val.shopId,
      encrypt_tels: val.encrypt_tels,
    });
    const rule = await this.spuService.getRule('mobile_info_url');
    const url = `${rule}${res}`;
    this.$copyText(String(url)).then(
      () => {
        this.$message.success('复制成功');
      },
      (err) => {
        this.$message.error(`复制失败:${err}`);
      },
    );
  }

  created() {
    this.shopId = this.$route.params.id;
    if (this.shopId.includes(':')) {
      this.$message.error('店铺不存在');
      return;
    }
    this.init();
  }
  listTatle(val: any) {
    this.shopTotal = val;
  }

  callback(val: any) {
    this.activeTab = val;
    if (val === '1') {
      this.init();
    } else if (val === '2') {
      this.$nextTick(() => {
        this.revisionRecordTable.init();
      });
    } else if (val === '3') {
      this.getAlbumShopInfo();
    } else if (val === '5') {
      this.$nextTick(() => {
        this.operatingData.init();
      });
    } else if (val === '6') {
      this.$nextTick(() => {
        this.merchantDivision.init();
      });
    }
  }

  albumData: any = {};

  async getAlbumShopInfo() {
    // console.log(this.shopId);
    const res = await this.shopService.albumShopInfo({
      shopId: this.shopId as string,
    });
    // console.log(res);
    this.albumData = res;
    this.$nextTick(() => {
      this.albumManagement.init();
    });
  }

  getBusinessAtagList(val: any) {
    // console.log(val, '-------------');
    if (!val) {
      return '';
    }
    const params = {
      amapAtagId: val,
    };
    const res = this.auditService.mainBusinessAtagList(params) as any;
    if (res) {
      // console.log(res);
      return res.name || '';
    }
    return '111';
  }

  @DebounceTime()
  touchShop() {
    if (!this.shopId) {
      return;
    }
    this.shopService.touchShop(this.shopId);
  }

  touchShopSpu() {
    if (!this.shopId) {
      return;
    }
    this.shopService.touchShopSpu(this.shopId);
  }

  async touchShopMerchant() {
    if (!this.shopId) {
      return;
    }

    const res = await this.shopService.touchShopMerchant(this.shopId);

    if (res) {
      this.$message.success('推送成功，正在刷新!');
      await $delay(2500);
      await this.refresh();
    }
  }

  async intervention(secondConfirm?: boolean) {
    if (!this.shopId) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;

    if (typeof secondConfirm !== 'undefined' && secondConfirm === true) {
      try {
        const res = await this.shopService.interventionShopMerchant(
          this.shopId,
          1,
        );
        if (res) {
          this.$message.success(res);
          await $delay(2500);
          await this.refresh();
        }
      } catch (error) {
        this.$message.error(`${error}`);
      }
      return;
    }

    const data = await this.shopService.interventionShopMerchant(this.shopId);
    if (data) {
      this.$confirm({
        title: '请仔细确认后再执行后续操作',
        content: `${data}`,
        okText: '继续执行',
        cancelText: '取消',
        onOk: async () => {
          await this.intervention(true);
        },
      });
      this.isLoading = false;
    }
  }

  @DebounceTime()
  async shopQueryInfo() {
    if (!this.shopId) {
      return;
    }
    const res = await this.shopService.getShopInfo({ shop_id: this.shopId });
    // console.log(res);
    if (res) {
      this.$message.success(res);
      this.init();
    }
  }

  /**
   * 页面刷新
   */
  async refresh(needShowToast = true) {
    if (this.activeTab === '1') {
      await this.init();
    } else if (this.activeTab === '2') {
      this.$nextTick(() => {
        this.revisionRecordTable.init();
      });
    }
    if (needShowToast === true) {
      this.$message.success('刷新成功!');
    }
  }

  /**
   * 同步推送语音到高德地图
   */
  async syncPushVoiceToAMap() {
    if (!this.shopId) {
      return;
    }
    const res = await this.shopService.shopEcSyncPushVoiceToAMap({
      shop_id: this.shopId,
    });
    if (res) {
      this.$message.success('操作成功');
    }
  }

  async asyncRightsOrder() {
    const res = await this.shopService.postCancelRightsOrder({
      shop_id: this.shopId,
    });
    if (res) {
      this.$message.success('操作成功');
      await this.refresh();
    }
  }
  /**
   * 初始化查询
   */
  async init() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data: any = await this.shopService.getShopDetail(
      this.shopId as string,
      this.$el,
    );
    // const id = this.$route.params.id;
    // const res = (await this.shopService.adUserBk(id));
    // this.adUserBind = res?.bind || false;
    await this.$nextTick();
    const PointDetail = await this.shopService.getPointDetail(this.shopId);
    this.funPointDetail(PointDetail.point);
    this.radius = PointDetail.radius;
    const { id } = this.$route.params;
    const res = await this.shopService.adUserBk(id);
    this.detail = data.detail;
    this.merchantInfo = data.merchantInfo;
    this.detail.advertiserMobilePhoneNumber = res?.ad_user_phone || '';
    this.detail.encrypt_ad_user_phone = res?.encrypt_ad_user_phone || '';
    const { regionid, regionpid, adcode } = data.city_code;
    this.addressInfo = {
      locationName: this.detail.name,
      address: this.detail.address,
      regions: [regionpid, regionid, adcode],
      latitude: this.detail.latitude,
      longitude: this.detail.longitude,
    };
    if (data.detail.mainBusinessAtagCode) {
      const BusinessAtag = (await this.auditService.mainBusinessAtagList({
        amapAtagId: data.detail.mainBusinessAtagCode,
      })) as any;
      if (BusinessAtag) {
        this.BusinessAtagName = BusinessAtag.name || '';
      }
    }
    const idCardInfo = await this.shopService.shopIdCardInfo(id);
    if (idCardInfo) {
      const { id_card_info, business_license_info } = idCardInfo;
      if (id_card_info) {
        this.idCardInfo = id_card_info;
      }
      if (business_license_info) {
        this.businessLicenseInfo = business_license_info;
      }
    } else {
      this.idCardInfo = {};
      this.businessLicenseInfo = {};
    }
    this.getShopDeta(id);
  }

  async getShopDeta(id: string) {
    const getShopClosetime = await this.shopService.getShopClosetime(id);
    // console.log('getShopClosetime', getShopClosetime);
    if (getShopClosetime) {
      this.shopDate = getShopClosetime;
    } else {
      this.shopDate = {
        stopDate: '',
        startDate: '',
      };
    }
  }

  async funPointDetail(poiPoints: any[]) {
    await AMapLoader.load({
      key: '6f5a626b93850e6e0d46610046818b13', // 申请的高德 Key
      version: '2.0',
      plugins: [
        'AMap.Scale',
        'AMap.ToolBar',
        'AMap.DistrictSearch',
        'AMap.Geocoder',
        'AMap.Circle',
        'AMap.Pixel',
        'AMap.Icon',
        'AMap.Pixel',
      ],
    });
    // const map = new AMap.Map('mapContainer', {
    //   zoom: 10,
    //   center: [this.detail.longitude, this.detail.latitude],
    //   resizeEnable: true,
    // });
    // this.map = map;
    const poi = new AMap.Geocoder();
    const PoiList: any = [];
    poiPoints.forEach((res: any) => {
      // this.addPoint(res.longitude, res.latitude, res.address, poi);
      const lnglat = {
        lng: res.longitude,
        lat: res.latitude,
      };

      poi.getAddress(lnglat, (status: string, result: any) => {
        if (status === 'complete' && result.regeocode) {
          const address = result.regeocode.formattedAddress;
          // const poiName = result.regeocode.poiList?.pois[0]?.name || '未知地点';
          // console.log('poiName:', poiName, address);
          const list = {
            longitude: res.longitude,
            latitude: res.latitude,
            lnglat: `${res.longitude}, ${res.latitude}`,
            address,
            id: res.id,
            radius: `${res.radius / 1000}公里`,
          };
          PoiList.push(list);
          // this.clickInfo = `✅成功！<br>经纬度: ${lng}, ${lat}<br>地址: ${address}      `;
        }
      });
    });
    this.PoiList = PoiList;
  }

  showLocation(data: any) {
    const { longitude, latitude, address } = data;
    this.lng = longitude;
    this.lat = latitude;
    this.locationName = address;
    this.locationView.show();
  }

  async delPoiVirtial(val: any) {
    if (this.PoiList.length === 1) {
      this.$message.error('至少保留一个虚拟门店');
      return;
    }
    const PoiList = this.PoiList.filter((item: any) => item.id !== val.id);

    const point = {
      point: PoiList.map((res: any) => {
        return {
          longitude: res.longitude,
          latitude: res.latitude,
          radius: this.radius,
        };
      }),
    };
    if (this.editType === '2') {
      this.hasUnsavedChanges = true;
      const Obj = point;
      this.multipleData = Object.assign({}, this.multipleData, Obj);
      return;
    }
    const res = await this.shopService.postPointEdit(this.shopId, point);
    if (res) {
      this.$message.success('操作成功');
      this.refresh();
    }
  }

  addPoiVirtial() {
    this.addVirtualPoi.init(this.radius);
  }

  lookPoiVirtial() {
    this.lookVirtualPoi.init(this.radius);
  }

  /** 修改营业状态 */
  async changeBusinessStatus(type: EShopBusinessStatus) {
    if (this.isLoading === true) {
      return;
    }
    this.isLoading = true;
    this.businessControl.changeBusinessStatus(type);

    setTimeout(() => {
      this.isLoading = false;
    }, 300);
  }

  /** 门店转让 */
  shopTransfer() {
    this.transfer.confirm();
  }

  /** 跳转至商品管理 */
  spuManage() {
    this.$router.push({
      name: 'main.shop.goods',
      params: {
        shopId: this.shopId as string,
        type: 'virtualShop',
      },
    });
  }

  /**
   * 返回
   */
  back() {
    this.$router.push({
      name: 'main.shop.list',
    });
  }

  /** 冻结 | 解冻 */
  changePayeeAccountStatus(status: EPayeeAccountFreezeStatus) {
    this.suspendAccount.confirm(status);
  }

  async migrate() {
    if (!this.shopId) {
      return;
    }
    // eslint-disable-next-line no-alert
    const targetPOI = prompt('请输入要迁往的 POI ID');

    if (targetPOI == null) {
      return;
    }

    this.shopService.migrateShop(this.shopId, targetPOI);
  }

  /**
   * 设为头图
   */
  setHeadImg(index: number) {
    const idList = this.detail.shopImages.map((item) => item.id);
    const head = idList.splice(index, 1);
    idList.unshift(head[0]);
    this.shopEdit({
      shopImage: idList,
    });
  }

  /**
   * 删除店铺图片
   */
  delShopImg(index: number) {
    if (this.detail.shopImages.length < 4) {
      this.$message.error('店铺相册图片不能小于3张');
    } else {
      const idList = this.detail.shopImages.map((item) => item.id);
      idList.splice(index, 1);
      this.shopEdit({
        shopImage: idList,
      });
    }
  }

  delShopVehicles(text: any) {
    const data = {
      [`${text}`]: [],
    };
    this.transferModifyShop(data);
  }

  delShopQualifications(id: any) {
    const data = this.detail.otherQualifications.map((res) => res.id);
    const _a = data.filter((item) => item !== id);
    // console.log(_a, id);
    this.transferModifyShop({
      otherQualifications: _a,
    });
  }

  /**
   * 修改店铺信息
   */
  async shopEdit(payload: { [key: string]: number[] | string[] }) {
    const result = await this.shopService.editShop<{
      [key: string]: number[] | string[];
    }>(this.shopId as string, payload);
    if (result) {
      this.$message.success('修改成功!正在审核中!');
    }
  }

  downloadQrcode() {
    this.isDrawing = true;
    this.drawQRCodePoster.downloadQrcode();
  }

  EOperationType = EOperationType;

  openVideoModal(obj: { url: string; cover: string; id: number }) {
    this.videoModal.open(obj.url);
  }

  editingField: IShopFormField | null = null;

  shopFields: { [key: string]: IShopFormField } = {
    [`${EShopField.NAME}`]: {
      labelName: '店铺名称',
      label: EShopField.NAME,
      value: '',
      type: 'name',
      rule: [
        {
          required: true,
          message: '请填写店铺名称',
          trigger: 'blur',
        },
        {
          pattern: /^[\u4e00-\u9fa5\\(\\)_a-zA-Z0-9]+$/,
          message: '门店名称仅支持：中英文、数字和半角括号()',
          trigger: 'blur',
        },
      ],
      fieldTitle: '编辑店铺名称',
      placeholder: '请输入店铺名称',
      submitAction: this.editShop,
    },
    [`${EShopField.ADDRESS}`]: {
      labelName: '店铺地址',
      label: EShopField.ADDRESS,
      value: null,
      type: EShopField.ADDRESS,
      fieldTitle: '编辑店铺地址',
      width: 1200,
      submitAction: this.editAddressInfo,
    },
    [`${EShopField.ADVERTISER_MOBILE_PHONE_NUMBER}`]: {
      labelName: '广告主电话',
      label: EShopField.ADVERTISER_MOBILE_PHONE_NUMBER,
      value: '',
      rule: [
        {
          required: true,
          message: '手机号不能为空',
          trigger: 'blur',
        },
        {
          pattern: /1[3-9]\d{9}/,
          message: '请输入正确的手机号',
          trigger: 'blur',
        },
      ],
      type: EShopField.ADVERTISER_MOBILE_PHONE_NUMBER,
      fieldTitle: '编辑广告主电话',
      placeholder: '请输入广告主电话',
      submitAction: this.editAdvertiserPhoneNum,
    },
    [`${EShopField.MANAGER_TELS}`]: {
      labelName: '经理电话',
      label: EShopField.MANAGER_TELS,
      value: '',
      rule: [
        {
          required: true,
          message: '手机号不能为空',
          trigger: 'blur',
        },
        {
          pattern: /1[3-9]\d{9}/,
          message: '请输入正确的手机号',
          trigger: 'blur',
        },
      ],
      type: EShopField.MANAGER_TELS,
      fieldTitle: '编辑经理电话',
      placeholder: '请输入经理电话',
      submitAction: this.editShop,
    },
    [`${EShopField.START_TIME}`]: {
      labelName: '开业时间',
      label: EShopField.START_TIME,
      value: '',
      type: EShopField.START_TIME,
      fieldTitle: '编辑开业时间',
      placeholder: '请选择开业时间',
      submitAction: this.editShop,
    },
    [`${EShopField.MAIN_BUSINESS}`]: {
      labelName: '经营范围',
      label: EShopField.MAIN_BUSINESS,
      value: '',
      type: EShopField.MAIN_BUSINESS,
      fieldTitle: '编辑经营范围',
      placeholder: '请选择经营范围',
      submitAction: this.editShop,
    },
    [`${EShopField.MAIN_BUSINESS_ATAG_CODE}`]: {
      labelName: '主营业务',
      label: EShopField.MAIN_BUSINESS_ATAG_CODE,
      value: '',
      type: EShopField.MAIN_BUSINESS_ATAG_CODE,
      fieldTitle: '编辑主营业务',
      submitAction: this.editShop,
    },
    [`${EShopField.TELS}`]: {
      labelName: '行业电话',
      label: EShopField.TELS,
      value: '',
      type: EShopField.TELS,
      fieldTitle: '编辑行业电话',
      placeholder: '支持11位手机号、400电话或固定座机号码',
      submitAction: this.editShop,
    },
    [`${EShopField.PRE_TELS}`]: {
      labelName: '营业电话',
      label: EShopField.PRE_TELS,
      value: '',
      type: EShopField.PRE_TELS,
      fieldTitle: '编辑营业电话',
      placeholder: '支持11位手机号、400电话或固定座机号码',
      submitAction: this.editShop,
    },
    [`${EShopField.BUSINESS_TIME}`]: {
      labelName: '营业时间',
      label: EShopField.BUSINESS_TIME,
      value: '',
      type: EShopField.BUSINESS_TIME,
      fieldTitle: '编辑营业时间',
      submitAction: this.editShop,
    },
    [`${EShopField.SHOP_VIDEOS}`]: {
      labelName: '店铺视频',
      label: EShopField.SHOP_VIDEOS,
      value: '',
      type: EShopField.SHOP_VIDEOS,
      fieldTitle: '编辑店铺视频）',
      submitAction: this.editShop,
    },
    [`${EShopField.VIDEOS}`]: {
      labelName: '实拍视频（门店审核）',
      label: EShopField.VIDEOS,
      value: '',
      type: EShopField.VIDEOS,
      fieldTitle: '编辑实拍视频（门店审核）',
      submitAction: this.editShop,
    },
    [`${EShopField.SHOP_IMAGES}`]: {
      labelName: '店铺图片',
      label: EShopField.SHOP_IMAGES,
      value: '',
      type: EShopField.SHOP_IMAGES,
      fieldTitle: '编辑店铺图片',
      submitAction: this.editShop,
    },
    [`${EShopField.SHOP_LICENSE}`]: {
      labelName: '营业执照',
      label: EShopField.SHOP_LICENSE,
      value: '',
      type: EShopField.SHOP_LICENSE,
      fieldTitle: '编辑营业执照',
      submitAction: this.editShop,
    },
    [`${EShopField.OTHER_QUALIFICATIONS}`]: {
      labelName: '其他资质',
      label: EShopField.OTHER_QUALIFICATIONS,
      value: '',
      type: EShopField.OTHER_QUALIFICATIONS,
      fieldTitle: '编辑其他资质',
      submitAction: this.editShop,
    },
    [`${EShopField.BOSS_ID_IMAGES}`]: {
      labelName: '身份证',
      label: EShopField.BOSS_ID_IMAGES,
      value: '',
      type: EShopField.BOSS_ID_IMAGES,
      fieldTitle: '编辑身份证',
      submitAction: this.editShop,
    },
    [`${EShopField.STAFF}`]: {
      labelName: '子账户管理',
      label: EShopField.STAFF,
      value: '',
      type: EShopField.STAFF,
      fieldTitle: '编辑店铺子账户',
      submitAction: this.closeShopEditor,
    },
    [`${EShopField.INDUSTRY_LICENSE}`]: {
      labelName: '行业资质',
      label: EShopField.INDUSTRY_LICENSE,
      value: '',
      type: EShopField.INDUSTRY_LICENSE,
      fieldTitle: '编辑行业资质',
      submitAction: this.editShop,
    },
    [`${EShopField.SHOP_LICENSE_VALID_UNTIL}`]: {
      labelName: '营业执照有效期',
      label: EShopField.SHOP_LICENSE_VALID_UNTIL,
      value: '',
      type: EShopField.SHOP_LICENSE_VALID_UNTIL,
      fieldTitle: '编辑营业执照有效期',
      submitAction: this.editShop,
    },
    [`${EShopField.SHOP_LICENSE_VALID_DATE_TYPE}`]: {
      labelName: '营业执照有效期类型',
      label: EShopField.SHOP_LICENSE_VALID_DATE_TYPE,
      value: '',
      type: EShopField.SHOP_LICENSE_VALID_DATE_TYPE,
      fieldTitle: '编辑营业执照有效期类型',
      submitAction: this.editShop,
    },
  };

  /** @todo 1.待确定直接关闭，还是需要刷新； 2.若直接关闭，刷新时机是什么？ 关闭和确认编辑窗口？还是更新任何子账户信息 */
  closeShopEditor() {
    this.shopEditor.close();
  }
  async editOnSiteService(param: { [key: string]: any }) {
    if (!this.shopId) {
      return;
    }
    try {
      const data = {
        shopId: this.shopId,
        onSiteService: param.onsiteServiceFlag,
      };
      const res = await this.shopService.editOnSiteServiceFlag(data);
      if (res) {
        this.$message.success(`${res}`);
        await this.refresh(false);
        this.shopEditor.close();
      }
    } catch (error) {
      this.$message.error(`${error}`);
    }
  }
  getMainBusiness(mainBusiness: any) {
    if (!mainBusiness) {
      return '';
    }
    const arr = mainBusiness.map((item: any) => {
      return EnumBizRange[item];
    });
    return arr.join('、');
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async openShopEditor(field: EShopField, val: any) {
    const target = Object.assign({}, this.shopFields[`${field}`]);
    target.value = val;
    this.editingField = target;
    if (field === EShopField.TELS || field === EShopField.PRE_TELS) {
      let text: any = '';
      let encrypt_phone: any = '';
      if (field === EShopField.TELS) {
        text = '门店详情-行业电话编辑';
        encrypt_phone = this.detail.encrypt_tels;
      } else if (field === EShopField.PRE_TELS) {
        text = '门店详情-营业电话编辑';
        encrypt_phone = this.detail.encrypt_pre_tels;
      }
      if (encrypt_phone) {
        const data = {
          encrypt_phone,
          operate_type: text,
          poi: this.detail.poi,
        };
        const res = await this.utilService.postPhoneDecrypt(data);
        this.editingField.value = res;
      }
    }

    setTimeout(() => {
      this.shopEditor.open();
    }, 500);
  }

  /** 编辑门店普通信息 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async editShop(param: { [key: string]: any }) {
    if (!this.shopId) {
      return;
    }
    const val = Object.entries(param)[0];
    if (val[0] === 'shopImages') {
      if (val[1].length < 3) {
        this.$message.error('店铺相册图片不能小于3张');
        return;
      }
    }
    let data: any = {
      [`${val[0]}`]: val[1],
    };
    if (val[0] === 'shopLicenseValidDateType') {
      data = val[1];
      // console.log(data);
      if (data.shopLicenseValidDateType === 1 && !data.shopLicenseValidUntil) {
        this.$message.error('请选择有效日期');
        return;
      }
    }
    if (this.editType === '2') {
      this.hasUnsavedChanges = true;
      const Obj = data;
      this.multipleData = Object.assign({}, this.multipleData, Obj);
      this.shopEditor.close();
    } else {
      try {
        const res = await this.shopService.modifyShop(this.shopId, data);
        if (res) {
          this.$message.success('操作成功');
          await this.refresh(false);
          this.shopEditor.close();
        }
      } catch (error) {
        this.$message.error(`${error}`);
      }
    }
  }

  async multiplePieces() {
    if (!this.shopId) {
      return;
    }
    if (Object.keys(this.multipleData).length === 0) {
      this.$message.error('当前没有修改内容，请先进行编辑操作！');
      return;
    }
    this.multipleModal.init();
  }

  async funModifyShop() {
    if (!this.shopId) {
      return;
    }
    try {
      const res = await this.shopService.modifyShop(
        this.shopId,
        this.multipleData,
      );
      if (res) {
        this.$message.success('操作成功');
        this.hasUnsavedChanges = false;
        this.multipleData = {};
        await this.refresh(false);
      } else {
        this.hasUnsavedChanges = false;
        this.multipleData = {};
      }
    } catch (error) {
      this.$message.error(`${error}`);
    }
  }

  editFunType() {
    if (this.editType === '1') {
      this.editType = '2';
      this.$message.success('已开启批量编辑模式');
    } else {
      this.editType = '1';
      this.$message.success('已关闭批量编辑模式');
      this.multipleData = {};
      this.hasUnsavedChanges = false;
    }
  }

  editPoiType(val: any) {
    // console.log(val);
    this.hasUnsavedChanges = true;
    const Obj = val;
    this.multipleData = Object.assign({}, this.multipleData, Obj);
  }

  shopOperation(shopId: any, shopName: any, type: any) {
    if (this.hasUnsavedChanges) {
      this.$confirm({
        title: '确定要离开吗',
        content: '请确定当前页面存在未保存的修改，是否继续离开？',
        onOk: () => {
          const routeUrl = `/#/shop/operation/${shopId}/${shopName}/${type}`;
          window.open(routeUrl, '_blank');
        },
        onCancel: () => {},
      });
    } else {
      const routeUrl = `/#/shop/operation/${shopId}/${shopName}/${type}`;
      window.open(routeUrl, '_blank');
    }
  }

  runningReport(shopId: string) {
    if (this.hasUnsavedChanges) {
      this.$confirm({
        title: '确定要离开吗',
        content: '请确定当前页面存在未保存的修改，是否继续离开？',
        onOk: () => {
          const routeUrl = `/#/shop/running-report/${shopId}`;
          window.open(routeUrl, '_blank');
        },
        onCancel: () => {},
      });
    } else {
      const routeUrl = `/#/shop/running-report/${shopId}`;
      window.open(routeUrl, '_blank');
    }
  }

  async transferModifyShop(val: any) {
    if (!this.shopId) {
      return;
    }
    try {
      const res = await this.shopService.modifyShop(this.shopId, val);
      if (res) {
        this.$message.success(`${res}`);
        await this.refresh(false);
        this.shopEditor?.close();
      }
    } catch (error) {
      this.$message.error(`${error}`);
    }
  }

  /** 编辑门店地址：
   * 1. 省市区
   * 2. 详细地址
   * 3. 经纬度扎点
   */
  async editAddressInfo(param: { [key: string]: IEditShopFieldAddress }) {
    if (!this.shopId) {
      return;
    }

    const value = Object.entries(param)[0];
    try {
      const val: {
        regionid: number;
        regionpid: number;
        adcode: number;
        address: string;
        latitude: number | string;
        longitude: number | string;
      } = {
        regionpid: value[1].regions[0],
        regionid: value[1].regions[1],
        adcode: value[1].regions[2],
        address: value[1].address,
        latitude: value[1].latitude,
        longitude: value[1].longitude,
      };

      if (this.editType === '2') {
        this.hasUnsavedChanges = true;
        const Obj = val;
        this.multipleData = Object.assign({}, this.multipleData, Obj);
        this.shopEditor.close();
        return;
      }
      const res = await this.shopService.editAddressInfo(
        Object.assign(val, { shopId: +this.shopId }),
      );
      if (res) {
        this.$message.success(`${res}`);
        await this.refresh();
        this.shopEditor.close();
      }
    } catch (error) {
      this.$message.error(`${error}`);
    }
  }

  /** 编辑广告主手机号码 */
  async editAdvertiserPhoneNum(param: { [key: string]: string }) {
    if (!this.shopId) {
      return;
    }
    try {
      const data = {
        ad_user_phone: param.advertiserMobilePhoneNumber,
      };
      const res = await this.shopService.adUserAddBk(this.shopId, data);
      // const val = Object.entries(param)[0];
      // const phone = val[1];

      // const res = await this.shopService.modifyAdvertiserMobilePhoneNumber(
      //   this.shopId,
      //   phone,
      // );
      if (res) {
        this.$message.success(`${res}`);
        await this.refresh();
        this.shopEditor.close();
      }
    } catch (error) {
      this.$message.error(`${error}`);
    }
  }

  editInformation() {
    this.shoplLicenseModal.init();
  }
  editIdCardInfo() {
    this.idCardModal.init();
  }

  funAutoPauseResume() {
    this.autoPauseResume.init(this.shopDate);
  }
}
